import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'reactstrap';

/**
 * NeoCard
 * Contêiner e cartão premium unificado. Trata cabeçalhos conceituais,
 * ícones circulares outonais, respiros simétricos, Outfit e bordas do tema.
 */
const NeoCard = ({
    title = null,
    subtitle = null,
    headerIcon = null, // e.g. 'mdi-chart-line'
    headerActions = null, // Elementos JSX de ação (como botões)
    children,
    className = '',
    style = {},
    noBorder = false,
    thinBorder = false,
    bodyClassName = '',
    bodyStyle = {},
    ...props
}) => {
    const cardStyle = {
        borderRadius: '16px',
        border: noBorder 
            ? 'none' 
            : thinBorder 
                ? '1.5px solid rgba(72, 39, 18, 0.12)' 
                : '2px solid var(--color-brand-primary)',
        boxShadow: noBorder ? 'none' : 'var(--shadow-premium-elevated)',
        backgroundColor: 'var(--color-bg-surface)',
        fontFamily: 'Outfit, sans-serif',
        overflow: 'hidden',
        ...style
    };

    const hasHeader = title || subtitle || headerIcon || headerActions;

    return (
        <Card className={`neo-stat-card animate__animated animate__fadeIn ${className}`} style={cardStyle} {...props}>
            {hasHeader && (
                <CardHeader 
                    className="d-flex align-items-center justify-content-between p-4 bg-transparent border-bottom-0 pb-1"
                    style={{ borderBottom: 'none' }}
                >
                    <div className="d-flex align-items-start">
                        {headerIcon && (
                            <div 
                                className="d-flex align-items-center justify-content-center flex-shrink-0 me-3"
                                style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '10px', // Mesma borda arredondada de 10px dos botões
                                    background: 'rgba(226, 102, 28, 0.08)',
                                    border: '1.5px solid rgba(226, 102, 28, 0.20)',
                                    marginTop: '2px' // Alinha perfeitamente com a primeira linha do título principal
                                }}
                            >
                                <i className={`mdi ${headerIcon} font-size-18`} style={{ color: 'var(--color-brand-accent)' }}></i>
                            </div>
                        )}
                        <div>
                            {title && (
                                <h5 className="mb-0 fw-bold font-size-15 text-uppercase" style={{ color: 'var(--color-brand-primary)', letterSpacing: '0.5px', fontFamily: 'Outfit, sans-serif' }}>
                                    {title}
                                </h5>
                            )}
                            {subtitle && (
                                <small className="text-muted font-size-11 fw-semibold d-block mt-0.5" style={{ letterSpacing: '0.3px', fontFamily: 'Outfit, sans-serif' }}>
                                    {subtitle}
                                </small>
                            )}
                        </div>
                    </div>
                    {headerActions && (
                        <div className="d-flex align-items-center gap-2">
                            {headerActions}
                        </div>
                    )}
                </CardHeader>
            )}
            <CardBody className={bodyClassName || 'p-4'} style={{ flex: '1 1 auto', ...bodyStyle }}>
                {children}
            </CardBody>
        </Card>
    );
};

NeoCard.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    headerIcon: PropTypes.string,
    headerActions: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    noBorder: PropTypes.bool,
    thinBorder: PropTypes.bool,
    bodyClassName: PropTypes.string,
    bodyStyle: PropTypes.object
};

export default NeoCard;
